import React, { Component } from 'react';
import axios from 'axios';
import TextInput from '../FormInputs/TextInput';
import CheckBox from '../FormInputs/CheckBox';
import Logo from '../FormInputs/Logo';
import env from '../../config/env';
import { NavLink } from 'react-router-dom';
import Loader from '../Loader/Loader';


class LoginForm extends Component {
  state = {
    email: "",
    password: "",
    errorEmail: "",
    errorPassword: "",
    agree: false,
    isAuthenticated: false,
    loading: false
  }
  changeValue = (keyVal, value) => {
    let prop = {};
    prop[keyVal] = value;
    return this.setState(prop);
  }

  handleSignIn(e) {
    this.setState({
      loading: true
    })
    e.preventDefault();
    const { email, password, agree } = this.state;
    var baseUrl = env.appPath + 'users/login';
    var payload = {
      "email": email,
      "password": password,
      "agree": agree
    };
    console.log(payload)
    axios.post(baseUrl, payload)
      .then((response) => {
        console.log(response);
        if (response.data.status === 'success') {
          this.setState({
            isAuthenticated: true
          });
          sessionStorage.setItem('token', response.data.token)
          this.props.history.push('/home');
        }
        else {
          this.setState({
            loading: false
          })
        }
        if (response.data.status === 'validationError') {
          this.setState({
            errorEmail: response.data.validationErrors.email,
            errorPassword: response.data.validationErrors.password,
          });
        } else if (response.data.status === 'userNotFound') {
          this.setState({
            errorEmail: response.data.message
          });
        } else if (response.data.status === 'passwordIncorrect') {
          this.setState({
            errorPassword: response.data.message
          });
        }
      }).catch((err) => {
        console.log(err);
      });
  }


  render() {
    const { loading } = this.state;

    return (
      <div>
        {
          loading &&
          <Loader />
        }
        <form className="form">
          <div className="header header-primary text-center">
            <h4>Sign in</h4>
          </div>
          <Logo />
          <div className="content">
            <TextInput placeholder="Email Address" inputValue={this.state.email} keyVal="email" changeValue={this.changeValue} message={this.state.errorEmail} />
            <TextInput placeholder="Password" inputValue={this.state.password} keyVal="password" changeValue={this.changeValue} message={this.state.errorPassword} />
            <CheckBox labelText="Remember Me" inputValue={this.state.agree} keyVal="agree" changeValue={this.changeValue} message={this.state.errorAgree} />
          </div>
          <div className="footer text-center">
            <button className="btn btn-info btn-raised" onClick={(e) => this.handleSignIn(e)}>Sign In</button>
          </div>
          <NavLink to="/register" className="btn btn-wd">Register Here</NavLink>
        </form>
      </div>
    )
  }
}

export default LoginForm;





// WEBPACK FOOTER //
// ./src/Components/Login/LoginForm.js